import axios, { CancelTokenSource } from "axios";

let debounceTimer: NodeJS.Timeout;
let cancelTokenSource: CancelTokenSource;

export async function debounceAndTokenizeApiCall<T>(
  endPoint: string,
  debounceDelay: number,
  params?: Record<string, string | null | undefined>,
): Promise<T> {
  if (debounceTimer) clearTimeout(debounceTimer);

  return new Promise((resolve, reject) => {
    debounceTimer = setTimeout(async () => {
      try {
        if (cancelTokenSource) cancelTokenSource.cancel();
        cancelTokenSource = axios.CancelToken.source();

        const response = await axios.get(endPoint, {
          params,
          cancelToken: cancelTokenSource?.token,
        });

        resolve(response.data);
      } catch (error) {
        if (!axios.isCancel(error)) reject(error);
      }
    }, debounceDelay);
  });
}
